import PalDockLogo from "assets/paldock_logo.svg";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";

export const PaldockFooter: FC = () => {
    const { t } = usePaldockTranslation("general");
    return (
        <footer className="text-center px-4 py-4">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 text-md">
                <span className="flex items-center gap-1">
                    {t("powered_by")}{" "}
                    <a href="https://paldock.com" target="_blank" rel="noopener noreferrer">
                        <img src={PalDockLogo} alt="PalDock" className="h-4 inline-block" />
                    </a>
                </span>
                <span className="hidden sm:inline">|</span>
                <span>{t("made_with_love_for_affiliates")}</span>
            </div>
        </footer>
    );
};
